var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    enableBackground: "new 0 0 15 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M15,3.0442c0.0017-0.5901-0.3911-1.3361-1.0508-1.9961c-0.8688-0.8658-2.084-1.408-2.7276-0.7683L1.5885,9.9174 c-0.2951,0.2931-0.762,1.7295-1.3877,4.2688L0,15l0.8136-0.2019c2.5394-0.6289,3.9767-1.0957,4.2714-1.3878l9.6328-9.6379 C14.8463,3.6452,14.9996,3.4149,15,3.0442z M11.9071,1.0167c0.1268-0.043,0.6897,0.1115,1.3277,0.7477 c0.6342,0.6345,0.7916,1.1932,0.7696,1.2906l-0.2843,0.2844l-2.0662-2.0673L11.9071,1.0167z M10.9405,1.9894l2.0638,2.0649 l-7.5805,7.5846L3.36,9.574L10.9405,1.9894z M1.3912,13.6066c0.3583-1.3689,0.7616-2.7249,0.9285-2.9897l0.3265-0.326l2.0645,2.0656 L4.4,12.6689C4.1639,12.8296,2.7835,13.2415,1.3912,13.6066z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEdit);
export default __webpack_public_path__ + "static/media/BtnEdit.30d688b86ffa0d927195c089eb701959.svg";
export { ForwardRef as ReactComponent };